import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useUrlStates = () => {
  const location = useLocation();

  // Derive isShare from current path
  const isShare = useMemo(() => {
    return location.pathname.includes("share");
  }, [location.pathname]);

  return { isShare };
};
